import english from '../../../public/locales/en/patientGuides.json';
import ar from '../../../public/locales/ar/patientGuides.json';
import bn from '../../../public/locales/bn/patientGuides.json';
import es from '../../../public/locales/es/patientGuides.json';
import fa from '../../../public/locales/fa/patientGuides.json';
import fr from '../../../public/locales/fr/patientGuides.json';
import gu from '../../../public/locales/gu/patientGuides.json';
import it from '../../../public/locales/it/patientGuides.json';
import pa from '../../../public/locales/pa/patientGuides.json';
import pl from '../../../public/locales/pl/patientGuides.json';
import pt from '../../../public/locales/pt/patientGuides.json';
import ro from '../../../public/locales/ro/patientGuides.json';
import so from '../../../public/locales/so/patientGuides.json';
import tl from '../../../public/locales/tl/patientGuides.json';
import tr from '../../../public/locales/tr/patientGuides.json';
import ur from '../../../public/locales/ur/patientGuides.json';
import zh from '../../../public/locales/zh/patientGuides.json';

export const localeOptions = [
  { code: 'ar', name: 'Arabic', direction: 'rtl' },
  { code: 'bn', name: 'Bengali', direction: 'ltr' },
  { code: 'es', name: 'Spanish', direction: 'ltr' },
  { code: 'fa', name: 'Persian (Farsi)', direction: 'rtl' },
  { code: 'fr', name: 'French', direction: 'ltr' },
  { code: 'gu', name: 'Gujarati', direction: 'ltr' },
  { code: 'it', name: 'Italian', direction: 'ltr' },
  { code: 'pa', name: 'Punjabi (Gurmukhi)', direction: 'ltr' },
  { code: 'pl', name: 'Polish', direction: 'ltr' },
  { code: 'pt', name: 'Portuguese', direction: 'ltr' },
  { code: 'ro', name: 'Romanian', direction: 'ltr' },
  { code: 'so', name: 'Somali', direction: 'ltr' },
  { code: 'tl', name: 'Filipino (Tagalog)', direction: 'ltr' },
  { code: 'tr', name: 'Turkish', direction: 'ltr' },
  { code: 'ur', name: 'Urdu', direction: 'rtl' },
  { code: 'zh', name: 'Simplified Chinese', direction: 'ltr' },
];

const bundles = { en: english, ar, bn, es, fa, fr, gu, it, pa, pl, pt, ro, so, tl, tr, ur, zh };
const requiredArrayFields = ['ask_about', 'how_they_help', 'when_you_might_meet', 'what_they_do'];

function versionOf(guide) {
  return Number(guide?.sourceVersion ?? guide?.version ?? 0);
}

function translatedVersionOf(guide) {
  return Number(guide?.translatedVersion ?? guide?.sourceVersion ?? guide?.version ?? 0);
}

function isComplete(guide) {
  if (!guide || typeof guide !== 'object' || !String(guide.summary || '').trim()) return false;
  return requiredArrayFields.every((field) => Array.isArray(guide[field]) && guide[field].length > 0);
}

export const translationRoleKeys = Object.keys(english.items || {});

export function getLocale(code) {
  return localeOptions.find((locale) => locale.code === code) || localeOptions[0];
}

export function getGuide(roleKey, locale = 'en') {
  return bundles[locale]?.items?.[roleKey] || null;
}

export function getTranslationRecord(roleKey, locale) {
  const source = getGuide(roleKey, 'en');
  const translated = getGuide(roleKey, locale);
  const sourceVersion = versionOf(source);
  const translatedVersion = translatedVersionOf(translated);
  let dataStatus = 'current';

  if (!translated) dataStatus = 'missing';
  else if (!isComplete(translated)) dataStatus = 'invalid';
  else if (translatedVersion < sourceVersion) dataStatus = 'stale';

  return {
    roleKey,
    locale,
    source,
    translated,
    sourceVersion,
    translatedVersion,
    dataStatus,
    method: translated?._translation?.method || 'legacy',
    provider: translated?._translation?.provider || null,
    generatedAt: translated?._translation?.generatedAt || null,
    machineReviewStatus: translated?._translation?.reviewStatus || 'unrecorded',
    direction: getLocale(locale).direction,
  };
}

export function localeReleaseSummary(locale) {
  return translationRoleKeys.reduce((summary, roleKey) => {
    const status = getTranslationRecord(roleKey, locale).dataStatus;
    summary[status] = (summary[status] || 0) + 1;
    return summary;
  }, { current: 0, stale: 0, missing: 0, invalid: 0 });
}
